import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import BntMoreSupply from '../PopUps/BntMoreSupply';
import PowerButton from '../Button/ButtonCard/PowerButton';
import './Card.css';

/**
 * PowerSupply component renders a card with power supply information.
 * 
 * @component
 * @param {Object} props - The properties object.
 * @param {Function} props.handleBasePower - The callback function to handle base power.
 * @param {Function} props.handleRedundantPower - The callback function to handle redundant power.
 */
const PowerSupply = ({
  /**
   * The callback function to handle base power.
   */
  handleBasePower,
  /**
   * The callback function to handle redundant power.
   */
  handleRedundantPower
}) => {
  return (
    <Card 
      variant="outlined" 
      sx={{ 
        /**
         * Custom styles for the card container
         */
        width: '430px', 
        height: '300px',
        marginLeft: '6.5%', 
        border: 'none', 
        boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px' 
      }}
    >
      <CardContent>
        <h3 style={{ 
          /**
           * Custom styles for the header
           */
          fontFamily: 'Open Sans', 
          marginTop: '1%', 
          justifyContent: 'center', 
          alignItems: 'center', 
          display: 'flex' 
        }}>
          Power Supply
        </h3>
        <p style={{ 
          /**
           * Custom styles for the paragraph
           */
          marginTop: '1%', 
          fontFamily: 'Open Sans', 
          fontSize: '12px', 
          color: '#2b8cb9' 
        }}>
          Select One
        </p>
        <div>
          <div style={{ 
            /**
             * Custom styles for the button container
             */
            justifyContent: 'center', 
            alignItems: 'center', 
            display: 'flex', 
            margin: '1%' 
          }}>
            <PowerButton text="Base Power" onClick={handleBasePower} />
          </div>
          <div style={{ 
            /**
             * Custom styles for the button container
             */
            justifyContent: 'center', 
            alignItems: 'center', 
            display: 'flex', 
            margin: '1%' 
          }}>
            <PowerButton text="Redundant Power" onClick={handleRedundantPower} />
          </div>
        </div>
        <p style={{ 
          /**
           * Custom styles for the paragraph
           */
          fontFamily: 'Open Sans', 
          fontSize: '12px', 
          marginRight: '16%' 
        }}>
          ADHA Power Supply Modules for the ADHA Racks.
        </p>
        <div style={{ 
          /**
           * Custom styles for the button container
           */
          display: 'flex', 
          justifyContent: 'flex-end' 
        }}>
          <BntMoreSupply size="small">More Info</BntMoreSupply>
        </div>
      </CardContent>
    </Card>
  );
};

/**
 * Exports the PowerSupply component as the default export.
 */
export default PowerSupply;